import { useSelector } from 'react-redux';
import { dictionariesSelector } from '../../store';
import { CompanySiteCaseStudy, CompanySiteForm } from '../../types/store';
import { IDictionariesForm } from '../components/Form/models';

type TF = () => {
  companySiteForm: CompanySiteForm | undefined;
  dictionariesForm: IDictionariesForm;
  companySiteFormLetsTalkTitle: string | undefined;
  companySiteFormLetsTalkText: string | undefined;
  companySiteTableOfContent: string | undefined;
  companySiteCaseStudy: CompanySiteCaseStudy | undefined;
  linkLabel: string | undefined;
  badgeLabel: string | undefined;
};
export const useLetsTalkFormDictionary: TF = () => {
  const {
    companySiteForm,
    companySiteTableOfContent,
    companySiteAllCasesStudy,
    companySiteCaseStudy,
  } = useSelector(dictionariesSelector) || {};
  const {
    companySiteFormLetsTalkName,
    companySiteFormLetsTalkAddInfo,
    companySiteFormLetsTalkEmail: {
      companySiteFormLetsTalkEmailError = '',
    } = {},
    companySiteFormLetsTalkTrackingID,
    companySiteFormLetsTalkRequiredField,
    companySiteFormLetsTalkSubmit,
    companySiteFormLetsTalkCompany,
    companySiteFormLetsTalkSuccessTitle,
    companySiteFormLetsTalkSuccessText,
    companySiteFormLetsTalkTitle,
    companySiteFormLetsTalkText,
    companySiteFormLetsTalkCompanyErrors: {
      companySiteFormLetsTalkCompanyMinCharactersError = '',
      companySiteFormLetsTalkCompanyMaxCharactersError = '',
    } = {},
    companySiteFormLetsTalkSubscribePolicy,
    companySiteFormLetsTalkPhone: {
      companySiteFormPhoneLetsTalkError = '',
    } = {},
    companySiteFormLetsTalkFirstName,
    companySiteFormLetsTalkLastName,
    companySiteFormLetsTalkMessage,
  } = companySiteForm?.companySiteFormLetsTalk || {};

  const dictionariesForm = {
    name: {
      label: companySiteFormLetsTalkName,
    },
    firstName: {
      label: companySiteFormLetsTalkFirstName,
    },
    lastName: {
      label: companySiteFormLetsTalkLastName,
    },
    phone: {
      label: 'Phone',
      error: companySiteFormPhoneLetsTalkError,
    },
    company: {
      label: companySiteFormLetsTalkCompany,
      error: {
        minError: companySiteFormLetsTalkCompanyMinCharactersError,
        maxError: companySiteFormLetsTalkCompanyMaxCharactersError,
      },
    },
    email: {
      label: 'Email',
      error: companySiteFormLetsTalkEmailError,
    },
    message: {
      label: companySiteFormLetsTalkMessage,
    },
    addInfo: {
      label: companySiteFormLetsTalkAddInfo,
    },
    success: {
      title: companySiteFormLetsTalkSuccessTitle,
      text: companySiteFormLetsTalkSuccessText,
    },
    required: companySiteFormLetsTalkRequiredField,
    button: companySiteFormLetsTalkSubmit,
    submitButtonID: companySiteFormLetsTalkTrackingID,
    policy: companySiteFormLetsTalkSubscribePolicy,
  };

  const {
    companySiteAllCasesStudyLinkLabel: linkLabel,
    companySiteAllCasesStudyBadgeLabel: badgeLabel,
  } = companySiteAllCasesStudy || {};

  return {
    companySiteForm,
    dictionariesForm,
    companySiteFormLetsTalkTitle,
    companySiteFormLetsTalkText,
    companySiteTableOfContent,
    companySiteCaseStudy,
    linkLabel,
    badgeLabel,
  };
};
